<template>
    <FormItem :label=label :prop=rule>
        <div>Not found</div>
    </FormItem>
</template>

<script>
export default {
    props: ["model", "rule", "label", "meta"]
};
</script>
